import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/address-book': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160h-20v64h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-20v64h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-20v48c0 26.5-21.5 48-48 48h-320c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h320c26.5 0 48 21.5 48 48v48h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zM368 464v-416h-320v416h320zM208 256c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM118.4 384c-12.4 0-22.4-8.6-22.4-19.2v-19.2c0-31.8 30.1-57.6 67.2-57.6 11.4 0 17.9 8 44.8 8 26.1 0 34-8 44.8-8 37.1 0 67.2 25.8 67.2 57.6v19.2c0 10.6-10 19.2-22.4 19.2h-179.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/address-book.js
// module id = 1684
// module chunks = 0